module.exports = __webpack_public_path__ + "img/Momentum_Cori_Pairing-Mode.51a581fd.png";